// Brand color presets for dynamic theme switching.
// The preset list mirrors Tailwind CSS v3 default color families at shade 500.

export const BRAND_COLOR_PRESETS = {
  slate: { hex: '#64748b' },
  gray: { hex: '#6b7280' },
  zinc: { hex: '#71717a' },
  neutral: { hex: '#737373' },
  stone: { hex: '#78716c' },
  red: { hex: '#ef4444' },
  orange: { hex: '#f97316' },
  amber: { hex: '#f59e0b' },
  yellow: { hex: '#eab308' },
  lime: { hex: '#84cc16' },
  green: { hex: '#22c55e' },
  emerald: { hex: '#10b981' },
  teal: { hex: '#14b8a6' },
  cyan: { hex: '#06b6d4' },
  sky: { hex: '#0ea5e9' },
  blue: { hex: '#3b82f6' },
  indigo: { hex: '#6366f1' },
  violet: { hex: '#8b5cf6' },
  purple: { hex: '#a855f7' },
  fuchsia: { hex: '#d946ef' },
  pink: { hex: '#ec4899' },
  rose: { hex: '#f43f5e' },
};

export const DEFAULT_BRAND_COLOR = 'green';

export const isHexColor = value => /^#[0-9a-fA-F]{6}$/.test(value || '');

const buildColorMixScale = hex => ({
  25: `color-mix(in srgb, ${hex} 6%, white)`,
  50: `color-mix(in srgb, ${hex} 12%, white)`,
  75: `color-mix(in srgb, ${hex} 20%, white)`,
  100: `color-mix(in srgb, ${hex} 30%, white)`,
  200: `color-mix(in srgb, ${hex} 45%, white)`,
  300: `color-mix(in srgb, ${hex} 65%, white)`,
  400: `color-mix(in srgb, ${hex} 82%, white)`,
  500: hex,
  600: `color-mix(in srgb, ${hex} 88%, black)`,
  700: `color-mix(in srgb, ${hex} 72%, black)`,
  800: `color-mix(in srgb, ${hex} 48%, black)`,
  900: `color-mix(in srgb, ${hex} 26%, black)`,
});

export const getBrandColorPreset = colorKey => {
  const fallback = BRAND_COLOR_PRESETS[DEFAULT_BRAND_COLOR];
  const preset = BRAND_COLOR_PRESETS[colorKey] || fallback;

  return {
    ...preset,
    scale: buildColorMixScale(preset.hex),
  };
};

export const getBrandColorValue = colorValue => {
  if (isHexColor(colorValue)) {
    return {
      hex: colorValue,
      scale: buildColorMixScale(colorValue),
    };
  }

  return getBrandColorPreset(colorValue);
};
